import { getConfig, setConfig } from './APIConfig';
import ValError from './ValidationError';

const config = getConfig();

setConfig(config);

export * from './auth';
export * from './companies';
export * from './departments';
export * from './employees';
export * from './hourTypes';
export * from './jobs';
export * from './licensing';
export * from './nonConformances';
export * from './payPeriods';
export * from './processScheduleDetails';
export * from './projects';
export * from './punchIns';
export * from './requestBuilder';
export * from './settings';
export * from './timeSheets';
export * from './modelMetadata';
export * from './timecards';
export * from './helpers';
export * from './gridSettings';

export const ValidationError = ValError;
export * from './QueryParameters';
export * from './GroupedQueryParameters';
export { default as GroupedResponse } from './GroupedResponse';
export { default as PagedResponse } from './PagedResponse';
export { default as ValidatedResponse } from './ValidatedResponse';
export { default as PagedRequest } from './PagedRequest';
export { default as AuthorizationError } from './AuthorizationError';
export { default as LicenseError } from './LicenseError';
export { default as Approver } from './Approver';
